import * as yup from 'yup';

export const rejectBookingInitialValues = {
  reason: '',
};

export const rejectBookingValidationSchema = yup.object().shape({
  reason: yup.string().required('Reason is required'),
});
